import React from 'react';
import PropTypes from 'prop-types';

import s from '../MLDialog.module.css';

const MLDialogTitle = ({ title, titleTextClassName = '' }) => {
  if (typeof title === 'string') {
    const className = `${s.dialogTitleText} ${titleTextClassName || ''}`;
    return (
      <span className={className} id="__mlDialog_title">
        {title}
      </span>
    );
  }

  return (
    <div className={s.dialogTitleContainer} id="__mlDialog_title">
      {title}
    </div>
  );
};

MLDialogTitle.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  titleTextClassName: PropTypes.string,
};

export default MLDialogTitle;
